module.exports = __webpack_public_path__ + "img/img9.a772054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img9.png
// module id = 184
// module chunks = 0